export default "__VITE_ASSET__DYLBZ10y__"